import { render } from "./TechinicalKnowledge.vue?vue&type=template&id=13395103&ts=true"
import script from "./TechinicalKnowledge.vue?vue&type=script&lang=ts"
export * from "./TechinicalKnowledge.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__